<!-- Ported from the Polaris kit: src/components/ui/tabs/TabsList.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { reactiveOmit } from '@vueuse/core';
import { TabsList } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  loop: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  // Polaris patch: "line" is the page-level variant (underline); the default stays the segmented control.
  variant: { type: String, required: false, default: 'default' },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class', 'variant');
</script>

<template>
  <TabsList
    data-slot="tabs-list"
    :data-variant="variant"
    v-bind="delegatedProps"
    :class="
      cn(
        'group/tabs-list bg-polaris-muted text-polaris-muted-foreground inline-flex h-9 w-fit items-center justify-center rounded-polaris-lg p-[3px]',
        variant === 'line' &&
          'h-9 w-full justify-start gap-6 rounded-none border-b border-solid border-polaris-border bg-transparent p-0',
        props.class
      )
    "
  >
    <slot />
  </TabsList>
</template>
